export const GET_PAYMENTS = 'GET_PAYMENTS';
export const PAYMENTS_RECEIVED = 'PAYMENTS_RECEIVED';
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT';
export const CREATE_PAYMENT = 'CREATE_PAYMENT';
export const DELETE_PAYMENT = 'DELETE_PAYMENT';
export const UPDATE_PAYMENT_RECEIVED = 'UPDATE_PAYMENT_RECEIVED';
export const CREATE_PAYMENT_RECEIVED = 'CREATE_PAYMENT_RECEIVED';
export const DELETE_PAYMENT_RECEIVED = 'DELETE_PAYMENT_RECEIVED';
